var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4604 6.71601L4.9142 1.68184C4.72867 1.58516 4.51369 1.52989 4.29186 1.52184C4.07004 1.51379 3.84957 1.55326 3.65367 1.6361C3.45776 1.71893 3.29366 1.84207 3.17863 1.99256C3.0636 2.14305 3.00189 2.31533 3 2.49126V12.5465C3.00021 12.7231 3.06095 12.8964 3.17572 13.0478C3.2905 13.1991 3.45501 13.323 3.65169 13.4061C3.84836 13.4892 4.06983 13.5284 4.29245 13.5196C4.51507 13.5108 4.73049 13.4542 4.9157 13.3559L14.4619 8.32177C14.6276 8.23312 14.7633 8.11362 14.8571 7.97374C14.9509 7.83386 15 7.67788 15 7.51948C15 7.36109 14.9509 7.20511 14.8571 7.06523C14.7633 6.92535 14.6276 6.80585 14.4619 6.7172L14.4604 6.71601Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.bfd86398d9f547be3ae210ad6edf6ac1.svg";
export { ForwardRef as ReactComponent };